import React from "react";
import Footer from "../Templete/Footer";
import Header from "../Templete/Header";
import SignupBanner from "../Home/SignupBanner";

const PANCardService = () => {
  // Set page title and meta description
  React.useEffect(() => {
    document.title =
      "PAN Card Services API | FORMAX PAY - NSDL & UTIITSL Authorized PAN Services Agent";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      const newMeta = document.createElement("meta");
      newMeta.name = "description";
      newMeta.content =
        "Authorized PAN service agent by Protean eGov & UTIITSL. NSDL & UTIITSL PAN card APIs for fintech platforms. SSO auto login, wallet integration, real-time status updates. Processing 8000+ PAN cards daily.";
      document.head.appendChild(newMeta);
    }
  }, []);

  return (
    <>
      <Header />

      {/* SEO: Structured Data Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "GovernmentService",
          name: "PAN Card Services API",
          description:
            "Authorized PAN service agent by Protean eGov & UTIITSL. Comprehensive PAN card APIs for NSDL & UTIITSL with SSO auto login and wallet integration.",
          provider: {
            "@type": "Organization",
            name: "Formax IT Solutions Private Limited",
            legalName: "Formax IT Solutions Private Limited",
            url: "https://formaxpay.com",
          },
          serviceType: ["PAN Card API", "KYC Services", "Verification API"],
          areaServed: "India",
          offers: {
            "@type": "Offer",
            category: "Government Services",
          },
        })}
      </script>

      {/* Hero Section */}
      <section className="bg-half-170 bg-light d-table w-100">
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-lg-10 text-center">
              <div className="pages-heading">
                <h1 className="title mb-4" style={{ fontSize: "2.5rem" }}>
                  PAN Card Services API
                </h1>
                <p className="text-muted para-desc mx-auto mb-0 fs-5">
                  Authorized Corporate PAN service agent by Protean eGov
                  Technologies Ltd & UTIITSL. Industry leader processing 8000+
                  PAN cards daily. Complete NSDL & UTIITSL API solutions.
                </p>
                <div className="mt-3">
                  <div className="badge bg-primary bg-opacity-10 text-white px-3 py-2 rounded-pill me-2">
                    <i className="uil uil-award me-1"></i>
                    Processing 8000+ PAN Cards Daily
                  </div>
                  <div className="badge bg-success bg-opacity-10 text-white px-3 py-2 rounded-pill">
                    <i className="uil uil-shield-check me-1"></i>
                    Authorized PAN Service Agent
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shape Divider */}
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      {/* Authorization Banner */}
      <section className="section bg-primary bg-opacity-10">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="section-title">
                <h4 className="title mb-3 text-white">
                  Authorized PAN Service Agent
                </h4>
                <p className="text-white mb-0">
                  <span className="text-white fw-bold">
                    FORMAX IT SOLUTIONS PRIVATE LIMITED
                  </span>{" "}
                  is authorized by
                  <span className="text-white fw-bold">
                    {" "}
                    Protean eGov Technologies Ltd & UTI Infrastructure
                    Technology And Services Limited
                  </span>{" "}
                  for appointing PAN service agents across PAN India and
                  providing comprehensive PAN card services.
                </p>
              </div>
            </div>
            <div className="col-lg-4 text-center">
              <div className="bg-white rounded p-4 shadow-sm">
                <h5 className="text-primary mb-2">Industry Leader</h5>
                <div className="display-4 text-primary fw-bold">8000+</div>
                <p className="text-muted small mb-0">
                  PAN Cards Processed Daily
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PAN Card Services Section */}
      <section className="section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div className="position-relative">
                <img
                  src="/images/pan-card-services.png"
                  className="rounded img-fluid mx-auto d-block"
                  alt="PAN Card Services API"
                />
              </div>
            </div>

            <div className="col-lg-7 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div className="section-title ms-lg-4">
                <h4 className="title mb-4">Complete PAN Card Solutions</h4>
                <p className="text-muted">
                  FORMAX PAY, the industry leader in PAN card services, provides
                  comprehensive PAN card solutions through authorized API
                  integration. Enable your platform to offer PAN services
                  directly to your users with
                  <span className="text-primary fw-bold">
                    {" "}
                    NSDL & UTIITSL approved
                  </span>{" "}
                  processing. Our APIs handle the complete lifecycle of PAN card
                  services.
                </p>
                <div className="row mt-4">
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        New PAN Card Application
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        PAN Card Reprint
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        PAN Card Update/Correction
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        PAN Verification API
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        PAN Status Tracking
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Bulk PAN Applications
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="section bg-light" id="features">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-4 pb-2">
                <h4 className="title mb-4">
                  Why Choose Our PAN Card Services API
                </h4>
                <p className="text-muted para-desc mx-auto mb-0">
                  Industry-leading PAN card API solutions with authorized NSDL &
                  UTIITSL integration
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-bolt-alt fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Fast Processing</h5>
                  <p className="text-muted mb-0">
                    Industry leader processing 8000+ PAN cards daily with
                    minimal turnaround time.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-shield-check fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Authorized Agent</h5>
                  <p className="text-muted mb-0">
                    Authorized by Protean eGov & UTIITSL for PAN service across
                    India.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-user-check fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">SSO Auto Login</h5>
                  <p className="text-muted mb-0">
                    Single Sign-On based auto login for PAN application portals.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-wallet fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Wallet Integration</h5>
                  <p className="text-muted mb-0">
                    Seamless wallet integration for PAN application payments.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-headphones-alt fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">24/7 Support</h5>
                  <p className="text-muted mb-0">
                    Round-the-clock customer support and automated billing
                    system.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-analytics fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Complete MIS Reports</h5>
                  <p className="text-muted mb-0">
                    Detailed dashboard with comprehensive reports and analytics.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NSDL & UTIITSL API Services Section */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-5">
                <h4 className="title mb-4">NSDL & UTIITSL API Services</h4>
                <p className="text-muted para-desc mx-auto">
                  Comprehensive API solutions for both NSDL and UTIITSL
                  platforms
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-6 mt-4">
              <div className="card border-0 features feature-primary p-4 h-100 rounded shadow">
                <div className="icon text-center rounded-circle mx-auto mb-3">
                  <i className="uil uil-server-network fs-2 text-primary"></i>
                </div>
                <div className="content text-center">
                  <h4 className="mb-3">NSDL PAN Services</h4>
                  <ul className="list-unstyled text-muted text-start">
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      SSL based auto login integration
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      Wallet integration for payments
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      Webhook integration for real-time status
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      PAN application status APIs
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      PAN status and transaction status APIs
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      Complete NSDL dashboard integration
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mt-4">
              <div className="card border-0 features feature-primary p-4 h-100 rounded shadow">
                <div className="icon text-center rounded-circle mx-auto mb-3">
                  <i className="uil uil-laptop-cloud fs-2 text-primary"></i>
                </div>
                <div className="content text-center">
                  <h4 className="mb-3">UTIITSL PAN Services</h4>
                  <ul className="list-unstyled text-muted text-start">
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      Register agent via API
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      Receive agent login details automatically
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      Auto login to UTI PSA portal
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      Buy coupons through API
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      Apply PAN through automated workflow
                    </li>
                    <li className="mb-2">
                      <i className="uil uil-check-circle text-success me-2"></i>
                      Complete UTIITSL process automation
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="section bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-5">
                <h4 className="title mb-4">Simple Integration Process</h4>
                <p className="text-muted para-desc mx-auto">
                  Get started with PAN card services in 4 easy steps
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-6 pt-2">
              <div className="card border-3 text-center features feature-primary p-3">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-user-plus fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">1. Register</h5>
                  <p className="text-muted mb-0">
                    Sign up as an API partner & complete documentation process
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 pt-2">
              <div className="card border-3 text-center features feature-primary p-3">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-key-skeleton fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">2. Get API Keys</h5>
                  <p className="text-muted mb-0">
                    Generate API credentials from dashboard, whitelist IP and
                    update webhook URLs
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 pt-2">
              <div className="card border-3 text-center features feature-primary p-3">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-arrow fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">3. Integrate</h5>
                  <p className="text-muted mb-0">
                    Implement PAN card APIs into your platform or application
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 pt-2">
              <div className="card border-3 text-center features feature-primary p-3">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-rocket fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">4. Go Live</h5>
                  <p className="text-muted mb-0">
                    Start offering PAN card services to your customers
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industry Leadership Section */}
      <section className="section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="section-title">
                <h4 className="title mb-4">
                  Industry Leader in PAN Card Services
                </h4>
                <p className="text-muted">
                  FORMAX is the leading player in the business segment and
                  industry leader for providing PAN services. With our
                  authorized status and advanced API infrastructure, we ensure
                  the fastest and most reliable PAN card processing.
                </p>
                <ul className="list-unstyled text-muted">
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Processing 8000+ PAN cards daily
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Authorized by Protean eGov & UTIITSL
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    24/7 customer support and auto billing
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    SSO based auto login for PAN portals
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Complete NSDL & UTIITSL API coverage
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Real-time status updates and webhooks
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Wallet integration for seamless payments
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Bulk PAN application processing
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/pan-industry-leader.png"
                className="img-fluid rounded shadow"
                alt="PAN Card Industry Leader"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="section bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-4">
                <h4 className="title mb-4">Ideal For</h4>
                <p className="text-muted para-desc mx-auto">
                  Our PAN card API is perfect for various business use cases
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 mt-4">
              <div className="card border-0 text-center features feature-primary p-4">
                <div className="icon text-center rounded-circle mx-auto mb-3">
                  <i className="uil uil-mobile-android fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Fintech Apps</h5>
                  <p className="text-muted mb-0">
                    Integrate PAN services into banking and financial apps for
                    customer onboarding.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4">
              <div className="card border-0 text-center features feature-primary p-4">
                <div className="icon text-center rounded-circle mx-auto mb-3">
                  <i className="uil uil-shopping-cart fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">E-commerce Platforms</h5>
                  <p className="text-muted mb-0">
                    Offer PAN card services as value-added service to your
                    customers.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4">
              <div className="card border-0 text-center features feature-primary p-4">
                <div className="icon text-center rounded-circle mx-auto mb-3">
                  <i className="uil uil-building fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Enterprise Solutions</h5>
                  <p className="text-muted mb-0">
                    Bulk PAN applications and verification for corporate
                    clients.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SignupBanner />

      <Footer />
    </>
  );
};

export default PANCardService;
